<template>
  <div>
    <div class="fixed-header">
      <div class="heading d-flex justify-space-between">
        {{ $t('provider.availability.title') }}
        <div class="send-buttons">
          <button class="button small warning notif-btn" @click="showSenfNotif">Send Notification</button>
          <button class="button small info sms-btn" @click="showSendSMS"><i class="fas fa-comment-dots"></i> Send SMS</button>
          <button class="button small info filter-btn" @click="showFilter" v-if="isMobile"><i class="fas fa-filter"></i></button>
        </div>
      </div>
      <transition name="slide-down">
        <table-filter ref="filter" v-show="isOpenFilter"></table-filter>
      </transition>
    </div>

    <div :class="{'tables-box':true, 'filterHide':!isOpenFilter}">
      <div class="export-box" v-show="isMobile ? !isOpenFilter : true">
        <button class="button small success cta" @click="xport.show = true">Export</button>
      </div>
      <driver-table class="tables" :isMobile="isMobile"></driver-table>
    </div>

    <div :class="['tables-box no-shift', {'filterHide':!isOpenFilter}]">
      <div class="t-label">Drivers with no availability <span>({{ dateToday }})</span></div>
      <no-shift-table class="tables" :isMobile="isMobile"></no-shift-table>
    </div>

    <notification-modal ref="notif"
      :isList="true" :provId="checked" :showGeofenceOption="true"
      :removeAllActiveUserOption="true" :hideTargetOption="false">
    </notification-modal>
    <sms-modal  ref="sms"
      :isList="true" :provId="checked" :showGeofenceOption="true"
      :removeAllActiveUserOption="true" :hideTargetOption="false">
    </sms-modal>

    <div :class="['modal', {'show':xport.show}]">
      <div class="bg-overlay" @click="closeExport"></div>
      <div class="modal-content">
        <div class="loading-box" v-show="xport.loading && !xport.success">
          <i class="fa fa-circle-notch fa-spin"></i>
          Loading...
        </div>

        <div class="flight-error" v-show="!xport.loading && !xport.success">
          <span class="title">Select which file to export:</span>
          <div class="file-type">
            <input type="checkbox" id="pdf" v-model="xport.pdf" />
            <label for="pdf">PDF</label>
          </div>
          <div class="file-type">
            <input type="checkbox" id="csv" v-model="xport.csv" />
            <label for="csv">CSV</label>
          </div>
        </div>

        <div class="error-box" v-if="!!xport.error">{{xport.error}}</div>

        <div class="row action" v-if="!xport.success">
          <div class="small-6 columns">
            <a href="javascript:;" :class="['button cta block small', {disabled:xport.loading}]" @click="closeExport">
              CANCEL
            </a>
          </div>
          <div class="small-6 columns">
            <a href="javascript:;" :class="['button cta warning block small', {disabled:xport.loading}]"
              @click="beginExport">
              EXPORT
            </a>
          </div>
        </div>

        <div class="success" v-if="xport.success">
          <i class="fas fa-check-circle fa-fw fa-3x"></i>
          <span>Export Success!</span>
          <div>
            <a href="javascript:;" class="button cta block small" @click="closeExport">CLOSE</a>
          </div>
        </div>
      </div>
    </div>

    <div id="pdf-view">
      <div v-for="(pageData, pageIndex) in xport.data" :class="['page', pageIndex]">
        <div class="title">Provider Availability</div>
        <div class="row filters-box">
          <div class="small-4 columns">
            <label>Work Sector</label>
            <div>{{workSector}}</div>
          </div>
          <div class="small-4 columns">
            <label>Start Date</label>
            <div>{{startDate}}</div>
          </div>
          <div class="small-4 columns">
            <label>End Date</label>
            <div>{{endDate}}</div>
          </div>
          <div class="small-4 columns">
            <label>Type</label>
            <div>{{_type}}</div>
          </div>
          <div class="small-4 columns">
            <label>Service</label>
            <div>{{tableFilter.service || 'All'}}</div>
          </div>
          <div class="small-4 columns">
            <label>Assignment</label>
            <div>{{assigned}}</div>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Business Name</th>
              <th>Type</th>
              <th>Home Sector</th>
              <th>Service</th>
              <th>Vehicle Type</th>
              <th>Available From</th>
              <th>Available Until</th>
              <th>Phone</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in pageData" :key="index">
              <td v-for="(value, i) in data" :class="[i]" :key="i">{{ value }}</td>
            </tr>
          </tbody>
        </table>
        <div class="page-count">page {{ currentPage(pageIndex) }} of {{ totalPage }}</div>
      </div>
    </div>
    
  </div>
</template>

<script>
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import notificationModal from '../App/NotificationModal'
import smsModal from '../App/SMSModal'
import tableFilter from './TableFilter'
import driverTable from './DriverTable'
import noShiftTable from './NoShiftTable'
import moment from 'moment'
import ft from '@/modules/api/featureToggle'
import CsvExport from 'csvexport'

export default {
  name: 'ProviderAvailability',
  components: { notificationModal, smsModal, tableFilter, driverTable, noShiftTable },
  data () {
    return {
      xport: {
        show: false,
        loading: false,
        pdf: true,
        csv: true,
        data: {},
        csvData: [],
        error: '',
        success: false
      },
      isMobile: false,
      isOpenFilter: true,
      dateToday: moment().format('MM/DD/YYYY')
    }
  },
  computed: {
    prov () { return this.$store.state.provider },
    checked () { return this.prov.availability.checked },
    totalPage () { return Object.keys(this.xport.data).length },
    tableFilter () { return this.prov.availability },
    workSector () {
      let index = this.prov.sectors.list.findIndex(x => x.id === this.tableFilter.sector)
      return index === -1 ? 'All' : (this.prov.sectors.list[index].name || '')
    },
    startDate () { return moment(this.tableFilter.since, 'X').format('MM/DD/YYYY hh:mmA') },
    endDate () { return moment(this.tableFilter.until, 'X').format('MM/DD/YYYY hh:mmA') },
    _type () { return this.tableFilter.type ? this.tableFilter.type.toUpperCase() : 'All' },
    assigned () {
      if (!this.tableFilter.assignedTrips) { return 'All' }
      return this.tableFilter.assignedTrips === '1' ? 'Assigned' : 'No Assignments'
    }
  },
  methods: {
    showFilter () {
      this.isOpenFilter = !this.isOpenFilter 
      console.log('test')
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    },
    showSenfNotif () {
      if (this.$refs.notif.showNotifForm()) {
        this.$refs.notif.showNotifForm()
      }
    },
    showSendSMS () {
      if (this.$refs.sms.showSMSForm()) {
        this.$refs.sms.showSMSForm()
      }
    },
    getBrands () {
      let self = this
      self.$sdk.get('/brand', {}, res => {
        if (res.error) { return }
        if (res.length) {
          self.$store.commit('brands/setList', res)
        }
      })
    },
    beginExport () {
      let self = this
      self.xport.success = false
      if (self.xport.loading) { return }
      if (!self.xport.pdf && !self.xport.csv) {
        self.xport.error = 'Select a file type.'
        return
      }
      self.xport.error = ''

      self.xport.loading = true
      let provider = self.$store.state.provider
      let availability = provider.availability
      let param = {
        token: self.$store.state.session.sessionToken,
        pageNum: 1,
        pageSize: 9999,
        order: availability.order,
        orderAsc: availability.orderAsc,
        vehicleType: null,
        sectorId: availability.sector,
        since: availability.since,
        until: availability.until
      }

      if (availability.service) {
        switch (availability.service) {
          case 'PAX':
            param.isPax = 1
            param.isDTD = 0
          break
          case 'DTD':
            param.isPax = 0
            param.isDTD = 1
          break
          case 'PAX/DTD':
            param.isPax = 1
            param.isDTD = 1
          break
        }
      }
      if (availability.type) param.licenseType = availability.type
      if (availability.vehicleType) param.vehicleType = availability.vehicleType
      if (availability.assignedTrips) param.assignments = availability.assignedTrips

      self.xport.data = {}
      self.xport.csvData = []
      self.$sdk.get('/shifts/dashboard', param, res => {
        if (res.error) {
          self.xport.loading = false
          console.log('ERROR', res.error.message)
          self.xport.error = res.error.message
          return
        }

        if (!res.list.length) {
          self.xport.loading = false
          self.xport.error = 'Empty Results.'
          return
        }

        let i = 1
        if (res.list.length) {
          res.list.forEach(function (prov) {
            let name = prov.businessName || `${prov.firstName} ${prov.lastName}`
            let availableFrom = ''
            let availableUntil = ''
            if (prov.startTimestamp) {
              availableFrom = moment(prov.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
              availableUntil = moment(prov.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
            }
            let paxDtd = ''
            if (prov.supportPax) { paxDtd = 'PAX' }
            if (prov.supportDTD) { paxDtd = 'DTD' }
            if (prov.supportPax && prov.supportDTD) { paxDtd = 'PAX/DTD' }
            if (!self.xport.data[`page${i}`]) {
              self.xport.data[`page${i}`] = []
            }

            self.xport.data[`page${i}`].push({
              id: prov.ID,
              businessName: name,
              type: prov.accountType.toUpperCase() || '',
              homeSector: prov.homeSectorName || '',
              service: paxDtd,
              vehicleType: prov.vehicleType || '',
              availableFrom: availableFrom,
              availableUntil: availableUntil,
              phone: prov.phoneNumber || ''
            })
            self.xport.csvData.push({
              'ID': prov.ID,
              'Business Name': name,
              'Type': prov.accountType.toUpperCase() || '',
              'Home Sector': prov.homeSectorName || '',
              'Service': paxDtd,
              'Vehicle Type': prov.vehicleType || '',
              'Available From': availableFrom,
              'Available Until': availableUntil,
              'Phone': prov.phoneNumber || ''
            })

            if (self.xport.data[`page${i}`].length >= 25) {
              i++
            }
          })

          if (self.xport.pdf) {
            self.processPdf(i)
          } else if (self.xport.csv) {
            self.processCsv()
          }
        }

      })
    },
    processPdf (page) {
      let self = this
      let start = moment(this.tableFilter.since, 'X')
      let end = moment(this.tableFilter.until, 'X')
      let pageAsyncs  = []
      let pdf = new jsPDF({ orientation: 'l', unit: 'mm', format: 'a4' })

      window.scrollTo(500, 0)
      document.body.style.overflow = 'hidden'

      self.$forceUpdate()
      setTimeout(() => {
        for (let i = 0; i < page; i++) {
          pageAsyncs.push(html2canvas(document.getElementsByClassName(`page${i + 1}`)[0], {
            scale: "1"
          }).then(canvas => {
            let imgData = canvas.toDataURL('image/jpeg', 0.9)
            pdf.addImage(imgData, 'JPEG', 0, 0)
            if (i + 1 !== page) { pdf.addPage() }
          }).catch(e => {
            self.xport.loading = false
            console.log('PDF ERROR:', e)
            document.body.style.overflow = 'auto'
            self.xport.error = e
          }))
        }
        Promise.all(pageAsyncs).then(() => {
          let timestamp = start.format('YYYYMMDD') + '-' + end.format('YYYYMMDD')
          pdf.save(`provider_availability ${timestamp}.pdf`)
          document.body.style.overflow = 'auto'
          if (self.xport.csv) {
            self.processCsv()
          } else {
            self.xport.loading = false
            self.xport.success = true
          }
        })
      }, 1000)
    },
    processCsv () {
      let start = moment(this.tableFilter.since, 'X')
      let end = moment(this.tableFilter.until, 'X')
      let timestamp = start.format('YYYYMMDD') + '-' + end.format('YYYYMMDD')
      const exporter = CsvExport.create({
        filename: `provider_availability ${timestamp}.csv`,
        columns: [
          'ID', 'Business Name', 'Type', 'Home Sector',
          'Service', 'Vehicle Type', 'Available From', 'Available Until',
          'Phone'
        ]
      })
      exporter.downloadCsv(this.xport.csvData)
      this.xport.loading = false
      self.xport.success = true
    },
    closeExport () {
      if (this.xport.loading) { return }
      this.xport.show = false
      this.xport.success = false
      this.xport.error = ''
    },
    currentPage (page) { return page.substring(4) },
  },
  mounted () {
    this.getBrands()
    this.setScreenSize()
  }
};
</script>

<style lang="scss" scoped>
.fixed-header{
  width: 100%;
}
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
}

.notif-btn, .sms-btn, .filter-btn {
  float: right;
  margin: 7px 10px;
}
.sms-btn {
  background-color: #16b0de;
}

.filter-btn {
  background-color: gray;
}

.tables-box{
  padding: 20px 40px 30px;
  overflow: auto;

  &.no-shift{
    max-width: 1100px;
  }
  .t-label{
    font-size: 21px;
    letter-spacing: .4px;
    font-weight: 600;
    line-height: 1;
    margin-bottom: 10px;
    color: #56666a;

    span{
      color: #939a9c;
      margin-left: 5px;
      display: inline-block;
    }
  }
}

.export-box{
  text-align: right;
  padding-bottom: 10px;
}
.action .columns{
  padding: 0 10px;
}
.modal{
  position: fixed;
  z-index: 12;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: column;
  justify-content: center;
  resize: vertical;

  .bg-overlay{
    position: absolute;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .modal-content{
    position: relative;
    z-index: 2;
    background: #fff;
    width: 400px;
    min-height: 150px;
    border-radius: 6px;
    padding: 20px;
    margin: auto;
    box-shadow: 1px 1px 5px 1px rgba(0,0,0, .3);
    display: none;
    text-align: center;
  }
  .loading-box{
    padding: 50px 0;
    font-size: 18px;

    i{
      color: #999;
      margin-right: 3px;
    }
  }
  .error-box{
    margin: 0 10px 10px;
    border: 2px solid #e00;
    background: rgba(255, 0, 0, .1);
    padding: 3px;
    color: #e00;
    font-size: 14px;
  }
  .success{
    i{
      color:#26D97A;
      font-size: 70px;
    }
    span{
      display: block;
      margin: 20px 0 30px;
      font-weight: 600;
    }
  }
  &.show{
    display: flex;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .15s ease-out;
      -moz-animation: slide-down .15s ease-out;
    }
  }
  .title{
    color: #555;
  }
  .file-type{
    display: inline-block;
    margin: 20px 0 40px;
    width: 48%;
    input{
      display: inline-block;
      width: 20px;
      margin:0 0 5px 0;
      cursor: pointer;
    }
    label{
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      vertical-align: 1px;
    }
  }
}

#pdf-view{
  position: fixed;
  top: 100%;
  right: 0;
  width: 1122px;
  height: 793px;
  background: #EFE;
  z-index: -2;

  .page{
    padding: 30px;
    position: relative;
    width: 100%;
    height: 100%;

    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 21px;
    margin-bottom: 20px;
  }
  .filters-box{
    margin-bottom: 40px;
    .columns{
      label{
        width: 100px;
        font-weight: 600;
        font-size: 14px;
        display: inline-block;
        text-align: right;
      }
      div{
        font-size: 14px;
        display: inline-block;
        width: calc(100% - 120px);
        border-bottom: 1px solid #999;
        padding-left: 5px;
      }
    }
  }

  table{
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;

    thead{
      font-weight: 600;
      tr:last-child th{ border-bottom: 1px solid #333; }
    }
    tbody{
      tr{
        &.subtotal, &.total{ font-weight: 700; }
        &.total{
          color: #000;
          font-size: 15px;
        }
      }
      td{
        padding: 2px 3px;
        text-align: center;
      }
    }
  }
}

@media only screen and (max-width: 430px) {
  .modal {
    .modal-content {
      width: auto;
    }
  }
  .fixed-header {
    // position: absolute;
    // height: 0;
  }
  .heading {
    flex-direction: column;
    .send-buttons {
      margin-left: -60px;
      display: flex;
      justify-content: center;
    }
  }
  .small-3 {
    width: 100%;
  }

  .export-box {
    // position: absolute;
    // margin-top: 90px;
    // left: 50%;
    // transform: translate(-50%, 0);
    width: 100%;
    // padding: 0 10px;
    margin: 50px 0 10px;

    button {
      width: 100%;
    }
  }

  .tables-box {
    // margin-top: 330px;
    z-index: 1;
    padding: 10px;
    .tables {
      // margin-top: 450px;
      margin-bottom: 30px;
    }
    .table-header .export-box .success {
      margin-right: 0;
    }
    &.filterHide {
      .tables {
        // margin-top: 140px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProviderAvailability/index.vue